import { Button } from "common/buttons";
import React from "react";

interface Props {
  children?: React.ReactNode;
  onClick?: () => void;
}

export const AbortButton: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  onClick,
}) => (
  <Button onClick={onClick} kind="secondary">
    {children ?? "Avbryt"}
  </Button>
);
